import React from 'react';
import { Routes, Route } from 'react-router-dom'

import InscricaoPage from "./pages/inscricao";
import ValidaInscricaoPage from "./pages/validaInscricao";
import LogoSummit from "./assets/logo-summit.png";
import LogoCongresso from './assets/logo-congresso-2026.png';

function MainRoutes() {
  return(
    // <Routes basename={`/${process.env.REACT_APP_DOMAIN.split("/")[3]}`}>
    <Routes>
      {/* <Route path="/summit-caruaru/" element={<InscricaoPage parcelas={[2]} Logo={LogoSummit} bgColor='bg-black' pageTitle='SUMMIT Caruaru' fkCongresso={1005} />} /> */}
      {/* <Route path="/summit-petrolina/" element={<InscricaoPage parcelas={[2]} Logo={LogoSummit} bgColor='bg-black' pageTitle='SUMMIT Petrolina' fkCongresso={1006} />} /> */}
      {/* <Route path="/summit-caruaru/check-in" element={<ValidaInscricaoPage fkCongresso={1005} />} /> */}
      {/* <Route path="/summit-petrolina/check-in" element={<ValidaInscricaoPage fkCongresso={1006} />} /> */}
      <Route path="/inscricaocongresso/" element={<InscricaoPage parcelas={[2, 3]} Logo={LogoCongresso} bgColor='bg-white' pageTitle='22º Congresso Internacional de Inovação na Educação' fkCongresso={1011} />} />
    </Routes>
  )
}

export default MainRoutes;